import { computed } from 'vue'
import { useTenantSettings } from '@/core/composables'
import {
  formatCalendarDateDisplay,
  formatDatetimeDisplay,
} from '@/core/utils/dateTime'

export const useGymDateDisplay = () => {
  const { dateFormat, timeFormat } = useTenantSettings()

  const displayDatetimeFormat = computed(() =>
    timeFormat.value === '24h'
      ? `${dateFormat.value} HH:mm`
      : `${dateFormat.value} hh:mm a`,
  )

  const formatPaidAt = (value: string | null | undefined) =>
    formatDatetimeDisplay(value, displayDatetimeFormat.value) || '—'

  const formatCalendarDate = (value: string | null | undefined) =>
    value ? formatCalendarDateDisplay(value, dateFormat.value) : '—'

  return {
    formatPaidAt,
    formatCalendarDate,
  }
}
